import React from 'react';
import { Box, Button, Card, Typography, Divider} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../../components/Buttons/BackButton';
import HttpService from '../../../services/HttpService';
import TitleLayout from '../../../components/layout/TitleLayout';
import SkeletonWrapper from '../../../components/Skeletons/SkeletonWrapper';
import MultipleMetadataFields from '../../../components/TemplatesForms/Selector/MultipleMetadataFields';

const EditNewForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [formValues, setFormValues] = React.useState<any>([]);
  const [formTitle, setFormTitle] = React.useState<string>('');

  const fetch = async () => {
    const resp = await HttpService.getAxiosClient().get(`/forms/${params.id}`);
    setFormTitle(resp.data?.appl_title_naming.title);
    setIsLoading(false);    
    setFormValues(resp?.data?.form_stacture || []);
  };

  const submitFormRequestEdit = async(values: any) => {
    try {
      setIsLoading(true);
      await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/forms/${params.id}`, {formFields: values});
      enqueueSnackbar('Η επεξεργασία του αιτήματος σας υποβλήθηκε επιτυχώς', { variant: 'success' });
      navigate('/admin/applications');
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Υπήρξε κάποιο πρόβλημα με την επεξεργασία του αιτήματος', { variant: 'error' });
    }
  };  

  const navigateBackToForms = () => {
    navigate('/admin/applications');
  };

  React.useEffect(() => {
    fetch();
  }, []);

  return (
    <>
      <TitleLayout>
        <Typography variant='h2'>Επεξεργασία Αιτήματος</Typography>
        <Box mt={2} mb={2}>
          <BackButton onClick={() => navigateBackToForms()} />
        </Box>
      </TitleLayout>
      <SkeletonWrapper loading={isLoading} skeletonLines={6}>
     
        <Card
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            padding: '16px',
            minWidth: '358px',
          }}
        >
          <Typography variant='h3' sx={{ display: 'flex', justifyContent: 'center' }}>
            {formTitle}
          </Typography>
          <Divider sx={{ m: 3 }} />
          <Box p={2}>
            <Box mt={4}>
              <MultipleMetadataFields hideValues
                formFields={formValues}
                setFormFields={setFormValues}
              />
            </Box>     
          </Box>
        </Card>
      </SkeletonWrapper>
      <Box mt={6}
        display='flex'
        justifyContent='flex-end' flexDirection={{xs: 'column', md: 'row'}}>
        <Button sx={{mr: 2}} onClick={navigateBackToForms}>Επιστροφή</Button>
        <Button
          variant='contained'
          color='primary'
          onClick={()=>submitFormRequestEdit(formValues)}
        >
          Ολοκλήρωση Επεξεργασίας
        </Button>
      </Box>
    </>
  );
}; 

export default EditNewForm;
